import { LegalPage, LegalSection, MailLink } from '../components/LegalPage';
import { BUSINESS, businessAddressInline } from '../lib/business';
import { useSiteContent } from '../hooks/useSiteContent';

export default function Returns() {
  const { content: contacts } = useSiteContent('site.contacts');
  return (
    <LegalPage
      title="Diritto di Recesso e Resi"
      description="Come esercitare il diritto di recesso entro 14 giorni e restituire i prodotti Apicoltura DePiccoli."
      lastUpdated="3 ottobre 2026"
    >
      <LegalSection title="1. Diritto di recesso">
        <p>
          Se sei un consumatore hai diritto di recedere dal contratto, senza dover fornire alcuna
          motivazione, entro <strong>14 giorni</strong> dal giorno in cui tu, o una persona da te
          indicata, ricevi i prodotti (artt. 52 e seguenti del Codice del Consumo). In caso di
          ritiro in apiario il termine decorre dal giorno del ritiro.
        </p>
      </LegalSection>

      <LegalSection title="2. Prodotti esclusi">
        <p>
          Ai sensi dell'art. 59, lett. e) del Codice del Consumo il recesso è escluso per i beni
          sigillati che non si prestano a essere restituiti per motivi igienici o di tutela della
          salute e che sono stati aperti dopo la consegna. Per questo{' '}
          <strong>non possiamo accettare la restituzione di vasetti aperti</strong> o con il
          sigillo di garanzia rimosso.
        </p>
        <p>
          Resta sempre salva la garanzia legale: se il prodotto è arrivato danneggiato o non
          conforme, la sostituzione o il rimborso sono gratuiti (vedi punto 6).
        </p>
      </LegalSection>

      <LegalSection title="3. Come esercitare il recesso">
        <p>
          Per esercitare il recesso inviaci, entro il termine di 14 giorni, una dichiarazione
          esplicita della tua decisione a <MailLink email={contacts.email} />, indicando il numero
          d'ordine. Puoi usare il modulo tipo riportato in fondo a questa pagina, ma non è
          obbligatorio.
        </p>
      </LegalSection>

      <LegalSection title="4. Restituzione dei prodotti">
        <p>
          I prodotti vanno restituiti integri, sigillati e ben imballati entro 14 giorni dalla
          comunicazione del recesso, all'indirizzo:
        </p>
        <p>
          <strong>{BUSINESS.legalName}</strong>
          <br />
          {businessAddressInline}
        </p>
        <p>
          Le spese di restituzione sono a tuo carico. Sei responsabile della diminuzione di valore
          dei prodotti dovuta a una manipolazione diversa da quella necessaria per stabilirne la
          natura e le caratteristiche.
        </p>
      </LegalSection>

      <LegalSection title="5. Rimborso">
        <p>
          Ti rimborseremo tutti i pagamenti ricevuti, comprese le spese di consegna standard,
          entro 14 giorni dal giorno in cui abbiamo ricevuto la comunicazione di recesso. Non
          rimborsiamo il costo aggiuntivo di una modalità di consegna più costosa di quella
          standard (ad esempio la spedizione espressa), se l'hai scelta tu.
        </p>
        <p>
          Il rimborso avviene con lo stesso mezzo di pagamento usato per l'acquisto, senza costi
          per te. Possiamo sospenderlo fino al ricevimento dei prodotti o fino alla prova della
          loro spedizione, se precedente.
        </p>
      </LegalSection>

      <LegalSection title="6. Prodotti danneggiati o non conformi">
        <p>
          Se un vasetto arriva rotto o il prodotto non corrisponde a quanto ordinato, scrivici a{' '}
          <MailLink email={contacts.email} /> entro 7 giorni dalla consegna con il numero d'ordine
          e, se possibile, una foto. Ti spediremo un prodotto sostitutivo o ti rimborseremo
          l'importo, senza spese, in base alla garanzia legale di conformità (artt. 128 e
          seguenti del Codice del Consumo).
        </p>
      </LegalSection>

      <LegalSection title="Modulo di recesso tipo">
        <p className="text-sm">(Compilare e restituire il presente modulo solo se si desidera recedere dal contratto)</p>
        <div className="rounded-lg border border-border bg-secondary/30 p-4 text-sm space-y-2">
          <p>
            Destinatario: {BUSINESS.legalName}, {businessAddressInline}, {contacts.email}
          </p>
          <p>
            Con la presente io/noi (*) notifico/notifichiamo (*) il recesso dal mio/nostro (*)
            contratto di vendita dei seguenti beni:
          </p>
          <p>Numero d'ordine: ____________________</p>
          <p>Ordinato il (*) / ricevuto il (*): ____________________</p>
          <p>Nome del/dei consumatore(i): ____________________</p>
          <p>Indirizzo del/dei consumatore(i): ____________________</p>
          <p>Firma del/dei consumatore(i) (solo se il modulo è inviato in versione cartacea): ____________________</p>
          <p>Data: ____________________</p>
          <p className="text-xs">(*) Cancellare la dicitura inutile.</p>
        </div>
      </LegalSection>
    </LegalPage>
  );
}
